import { api } from "@/api/client";

export default function Login() {
  const onLogin = () => {
    window.location.href = api.loginUrl(window.location.pathname + window.location.search);
  };
  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 px-6 text-center">
      <img
        src="/icon-512.png"
        alt="ArkiveAI"
        className="h-24 w-24 rounded-2xl"
      />
      <div>
        <h1 className="text-xl font-bold">ArkiveAI 지식 Q&A</h1>
        <p className="mt-1 text-sm text-muted-foreground">ArkiveAI 지식 저장소에 무엇이든 물어보세요.</p>
      </div>
      <button
        onClick={onLogin}
        className="w-full max-w-xs rounded-lg bg-[#0E1E2D] hover:bg-[#1C3954] px-4 py-3 font-semibold text-white active:opacity-90"
      >
        pilgrims 계정으로 로그인
      </button>
    </div>
  );
}
